import { defineMessages } from 'react-intl';

const messages = defineMessages({
  dataPoint1: {
    defaultMessage: 'Phishing',
    id: 'MRBNBk',
  },
  dataPoint2: {
    defaultMessage: 'Business email compromise',
    id: '1yKPau',
  },
  dataPoint3: {
    defaultMessage: 'Vulnerability in third-party software',
    id: 'V2aWvh',
  },
  dataPoint4: {
    defaultMessage: 'Stolen or compromised credentials',
    id: '2qMBq+',
  },
  dataPoint5: {
    defaultMessage: 'Malicious insider',
    id: 'FoH2il',
  },
  dataPoint6: {
    defaultMessage: 'Cloud misconfiguration',
    id: 'yAgIwA',
  },
  dataPoint7: {
    defaultMessage: 'Social engineering',
    id: 'IM2aKh',
  },
  dataPoint8: {
    defaultMessage: 'Physical security compromise',
    id: '9XkD+v',
  },
  dataPoint9: {
    defaultMessage: 'Accidental data loss or lost device',
    id: 'NSkDY/',
  },
  dataPoint10: {
    defaultMessage: 'System error',
    id: 'WvCXGT',
  },
  dropdownLabel: {
    defaultMessage: 'Explore an outcome',
    id: 'YbMANe',
  },
  filter1: {
    defaultMessage: 'Cost',
    id: 'fBG/Ge',
  },
  filter2: {
    defaultMessage: 'Frequency',
    id: 'vAW30j',
  },
  asteriskMessage: {
    defaultMessage: '*Costs are in millions in US dollars',
    id: '341XH4',
  },
});

export default messages;
